import { bindActionCreators } from 'redux';
import { connect } from '../../../../react-redux';
import { SidebarStimulus } from './presenter';
import { scrollToItem as scrollToItemAction } from '../../../../actions/scrolling';
function getStimulus(parent) {
  return parent.entryType === 'BankEntry' ? parent.getEntry().getEntry() : parent.getEntry();
}
export var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  return {
    childEntries: props.stimulusParent.getNestedEntries(),
    scrollToItem: props.scrollToItem || bindActionCreators(scrollToItemAction, dispatch)
  };
};
export var mapStateToProps = function mapStateToProps(state, props) {
  var stimulus = getStimulus(props.stimulusParent);
  var isShowingItems = state.getIn(['sidebar', stimulus.id], false);
  return {
    isShowingItems: isShowingItems,
    stimulus: stimulus
  };
};
export var Stimulus = connect(mapStateToProps, mapDispatchToProps)(SidebarStimulus);
export default Stimulus;